export default __webpack_public_path__ + "static/media/003-defibrillator.3231a7ae.png";